module.exports = __webpack_public_path__ + "img/23.74170b5b.png";